
export const findDataById = (config, id) => {
  const lIds = id.split('|');
  const localId = `${lIds.shift()}`;
  let select = config.routes ? config.routes.find(route => route.id === localId) : null;
  if (!select) {
    if (localId === 'zooms') {
      const idZoom = `${lIds.shift()}`;
      select = config.zooms.find(zoom => zoom.id === idZoom);
    } else if (config.products) {
      select = config.products.find(product => product.id === localId);
    } else if (config.zooms) {
      select = config.zooms.find(zoom => zoom.id === localId);
    }
  }
  if (!select) return null;
  if (lIds.length > 0) return findDataById(select, lIds.join('|'));
  return select;
};

export const getSectionLink = (config, id) => {
  const data = findDataById(config, id);
  if (data.routes) {
    if (data.routes[0].products && data.routes[0].products.length > 1) {
      return { name: `${id}|${data.routes[0].id}|${data.routes[0].products[0].id}` };
    }
    return { name: `${id}|${data.routes[0].id}` };
  }
  return { name: id };
};

export const getSections = (config) => {
  const collection = findDataById(config, 'collections');
  const sections = collection.routes.map(route => ({
    id: route.globalId,
    link: getSectionLink(config, route.globalId),
  }));
  return sections;
};


export const getSectionByRoute = (config, route) => {
  const id = route.name.split('|').slice(0, 2).join('|');
  const section = findDataById(config, id);
  const current = findDataById(config, route.name);
  let product;
  let content;
  let zoom;
  if (current.products) { // only one product
    content = current;
    product = content.products[0];
    zoom = content.zooms[0];
  } else if (current.face) { // multi products silver 10 for example
    content = findDataById(config, route.name.split('|').slice(0, -1).join('|'));
    product = current;
    zoom = content.products.length === 1 ? content.zooms[0] : content.zooms.find(zm => zm.product === product.id);
  } else if (current.file && route.name.indexOf('zoom') > -1) {
    content = findDataById(config, route.name.split('|').slice(0, -2).join('|'));
    product = content.products.length === 1 ? content.products[0] : content.products.find(prd => prd.id === current.product);
    zoom = current;
  }
  const children = section.routes ? section.routes.map(child => ({
    id: child.globalId,
    link: getSectionLink(config, child.globalId),
  })) : [];
  return {
    id,
    data: section,
    children,
    content,
    product,
    zoom,
  };
};


export default findDataById;
